export var IFrameCompanionMessage;
(function (IFrameCompanionMessage) {
    IFrameCompanionMessage["ON_PARAMS_FROM_COMPANION"] = "IFrameCompanionMessage.ON_PARAMS_FROM_COMPANION";
})(IFrameCompanionMessage || (IFrameCompanionMessage = {}));
